import { render, staticRenderFns } from "./detailImportBatchList_bak.vue?vue&type=template&id=be74e0b8&scoped=true&"
import script from "./detailImportBatchList_bak.vue?vue&type=script&lang=js&"
export * from "./detailImportBatchList_bak.vue?vue&type=script&lang=js&"
import style0 from "./detailImportBatchList_bak.vue?vue&type=style&index=0&id=be74e0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be74e0b8",
  null
  
)

export default component.exports